export default __webpack_public_path__ + "static/media/Animals_20.dc317adb.png";